import { DrawnSpaceShapeStatus } from 'utils/drawn-space-shape-types';

export const DRAWN_SPACE_ERROR_MESSAGES: Record<
  Exclude<DrawnSpaceShapeStatus, 'resolved'>,
  string
> = {
  'invalid-stroke': "That stroke didn't make a shape",
  'outside-footprint': 'Draw the space inside the footprint',
  'no-room': 'That area is already taken'
};

export const ADD_SPACE_RESETS_DESIGNS_MESSAGE =
  'Are you sure you want to add a space? This will reset all configurations and selected systems!';

export function getDrawnSpaceErrorMessage(
  status: Exclude<DrawnSpaceShapeStatus, 'resolved'>
): string {
  return DRAWN_SPACE_ERROR_MESSAGES[status];
}
